import { BottomNavProps } from './BottomNav.types'
import NavItem from './NavItem'
import styles from './BottomNav.module.css'

const BottomNav = ({ navItems, activePath, onNavClick }: BottomNavProps) => {
  return (
    <div
      className={`
        fixed bottom-4 left-1/2 transform -translate-x-1/2
        w-[95%] max-w-md z-40
        flex justify-between items-center
        bg-[var(--navbar-bg)] border border-[var(--bottom-nav-border)]
        rounded-md
        ${styles.bottomNav}
        p-2
        shadow-xl overflow-hidden
        font-ibm-plex-sans-thai
      `}
    >
      {navItems.map((item) => (
        <NavItem
          key={item.label}
          label={item.label}
          icon={item.icon}
          active={activePath === item.path}
          onClick={() => onNavClick(item.path)}
          path={item.path}
        />
      ))}
    </div>
  )
}

export default BottomNav
